module.exports = __webpack_public_path__ + "static/media/bg-red.92496e60.png";